import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-slide-over-content',
  templateUrl: './slide-over-content.component.html',
  standalone: true,
  styles: `
    @reference "tailwindcss";
    :host {
      @apply block h-full overflow-auto;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SlideOverContentComponent {}
